export var ThresholdType;
(function (ThresholdType) {
    ThresholdType["ValueRange"] = "value_range";
    ThresholdType["BodyMassIndexCategory"] = "bmi_category";
    ThresholdType["DeviationFromAverageRangePercentage"] = "deviation_average_percentage";
    ThresholdType["DeviationFromEarlierValue"] = "deviation_earlier";
    ThresholdType["PregnancyWeightGrowth"] = "pregnancy_weight";
    ThresholdType["BloodSugar"] = "glucose";
})(ThresholdType || (ThresholdType = {}));
